import { useState } from "react";
import Modal from "react-modal";
import { toast } from "react-hot-toast";
import { useGetAssignmentsQuery } from "@features/assignments/assignmentsApi";
import { useAddAssignmentMarkMutation } from "@features/assignmentMarks/assignmentMarksApi";
import InputWrapper from "@common/components/InputWrapper";
import useGetUserData from "@common/hooks/useGetUserData";

const AssignmentModal = ({ videoId, videoTitle, open, closeModal }) => {
  const [repo_link, setRepoLink] = useState("");

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
    },
  };

  Modal.setAppElement("#root");

  const { id, name } = useGetUserData();

  const { data: assignments } = useGetAssignmentsQuery() || [];

  const [addAssignmentMark, { isLoading }] = useAddAssignmentMarkMutation();

  const handleAssignmentSubmit = async (e) => {
    e.preventDefault();

    const assignment = assignments?.find((a) => a.video_id === videoId) || {};

    const data = {
      student_id: id,
      student_name: name,
      assignment_id: assignment?.id,
      title: assignment?.title,
      totalMark: assignment?.totalMark,
      mark: 0,
      repo_link,
      status: "pending",
      createdAt: new Date(),
    };

    const response = await addAssignmentMark(data);
    if (response?.data) {
      setRepoLink("");
      closeModal();
      toast.success("Assignment submitted successfully!");
    } else {
      toast.error("Assignment submitted failed!");
    }
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <h2 className="text-lg font-bold">{videoTitle}</h2>
      <button className="btn-modal-close" onClick={closeModal}>
        &times;
      </button>
      <form className="space-y-6" onSubmit={handleAssignmentSubmit}>
        <div className="rounded-md shadow-sm -space-y-px">
          <InputWrapper
            id="repo_link"
            name="repo_link"
            type="text"
            required
            className="form-input rounded"
            placeholder="Repository Link"
            value={repo_link}
            onChange={(e) => setRepoLink(e.target.value)}
          />

          <div className="submit-button-wrapper text-center">
            <button
              type="submit"
              disabled={isLoading}
              className="btn-submit font-bold w-full"
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default AssignmentModal;
